import Layout from '../components/Layout';
import MessagesComponent from '../components/Messages';
import BasicHeader from '../components/CommonComponents/BasicHeader';
import { useSelector } from 'react-redux';
import Pageheader from '../utils/headerHelment';

const Messages = () => {
    const { ndaData } = useSelector(state => state?.nda);
    const { selectedProject } = useSelector(state => state?.projectData);
    const { user } = useSelector(state => state.user);
    const userType = user?.types;

    // If user is consultant without signed NDA or no project selected,
    // we need to override the persistent layout
    if ((userType === 'Consultant' && ndaData?.nda_signed === false) || !selectedProject) {
        return (
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000, backgroundColor: 'white' }}>
                <Pageheader title="LENS - Messages" />
                <BasicHeader />
                <MessagesComponent />
            </div>
        );
    }

    // Otherwise use the persistent layout (handled at app level)
    return (
        <div className="container-fluid">
            <Pageheader title="LENS - Messages" />
            <MessagesComponent />
        </div>
    );
};

export default Messages;
